<template>
    <div class="row d-flex justify-content-start grid-doc">
        <div
            class="col-md-3 col-sm-12 p-2"
            v-for="(item, id) in arquivos"
            :key="id"
        >
            <div
                @click="openFolder(item)"
                @contextmenu.prevent="popMenu($event, `menu${id}`)"
            >
                <a :title="item.nome">
                    <div class="mx-3">
                        <img
                            v-if="item.tipo == 'image'"
                            :src="url + item.thumb"
                            :alt="item.nome"
                            class="img-fluid mx-auto d-block"
                            @click="$emit('view', item)"
                        />
                        <img
                            v-else
                            :src="`${url}img/files/${formatFile(
                                item.nome
                            )}.svg`"
                            :alt="item.nome"
                            class="img-fluid mx-auto d-block"
                            @click="$emit('view', item)"
                        />
                    </div>
                </a>
                <div class="caption text-center">{{ item.nome }}</div>
            </div>
            <div
                :id="`menu${id}`"
                style="display: none; z-index: 99"
                class="card card-body shadow p-1"
                @mouseleave="closerMenu(`menu${id}`)"
            >
                <button class="dropdown-item" @click="$emit('renomear', item)">
                    <i class="mdi mdi-form-textbox"></i>
                    <span class="pl-2">Renomear</span>
                </button>
                <!-- <button
                    v-if="
                        formatFile(item.nome) == 'zip' ||
                        formatFile(item.nome) == 'rar'
                    "
                    class="dropdown-item"
                    @click="download(item.caminho, item.nome)"
                >
                    <i class="mdi mdi-download"></i>
                    <span class="pl-2">Baixar</span>
                </button> -->
                <button class="dropdown-item" @click="downloadFile(item)">
                    <i class="mdi mdi-download"></i>
                    <span class="pl-2">Baixar</span>
                </button>

                <button class="dropdown-item" @click="$emit('deletar', item)">
                    <i class="mdi mdi-delete"></i>
                    <span class="pl-2">Deletar</span>
                </button>
                <!-- <button class="dropdown-item">
					<i class="mdi mdi-window-close"></i> <span class="pl-2">Fechar</span>
				</button> -->
            </div>
        </div>
        <h4 v-if="arquivos.length == 0" class="mx-auto">Pasta vazia.</h4>
    </div>
</template>
<script>
export default {
    props: ["arquivos"],
    data() {
        return {
            url: `${window.location.protocol}//${window.location.host}/`,
        };
    },
    methods: {
        closerMenu(id) {
            var display = document.getElementById(id);
            display.style.display = "none";
        },
        popMenu(e, id) {
            e.preventDefault();
            var display = document.getElementById(id);
            display.style.position = "absolute";
            display.style.display = "block";
            display.style.left = e.layerX + "px";
            display.style.top = e.layerY + "px";
        },
        openFolder(item) {
            if (!item.is_file) {
                this.$emit("open", item);
            }
        },
        formatFile(file) {
            var ex = file.split(".");
            return ex.length == 1 ? "folder_blue_a" : ex.pop();
        },
        downloadFile(anexo) {
            let path = this.url + anexo.caminho + "/" + anexo.nome;
            // window.open(path, "_blank");

            var anchor = document.createElement("a");
            anchor.href = path;
            anchor.download = path;
            document.body.appendChild(anchor);
            anchor.click();
        },
        download(fileUrl, fileName) {
            let timerInterval;
            swal.fire({
                html: "O arquivo está sendo preparado e logo será baixado.",
                timer: 2000,
                timerProgressBar: true,
                didOpen: () => {
                    swal.showLoading();
                    const b = swal.getHtmlContainer().querySelector("b");
                    timerInterval = setInterval(() => {
                        b.textContent = swal.getTimerLeft();
                    }, 100);
                },
                willClose: () => {
                    clearInterval(timerInterval);
                },
            }).then((result) => {
                /* Read more about handling dismissals below */
                if (result.dismiss === swal.DismissReason.timer) {
                    //console.log("I was closed by the timer");
                }
            });
            var a = document.createElement("a");
            a.href = fileUrl;
            a.setAttribute("download", fileName);
            a.click();
        },
    },
};
</script>
